<template>
  <div class="row mt-4">
    <div class="col-12">
      <ListTable
        :items="items"
        :columns="columns"
        :activeColumns="activeColumns"
        :hideNoResults="hideNoResults"
        @sort-by="setSort"
      >
        <!-- Name -->
        <template v-slot:col_name="{ item }">
          <span>{{
            item.name + (!!item.hvac_id ? ` (ID: ${item.hvac_id})` : "")
          }}</span>
        </template>

        <!-- Email (rendered via ListTable component) -->

        <!-- Company -->
        <template v-slot:col_company_name="{ item }">
          <span>{{
            item.company.name +
            (!!item.company.hvac_id ? ` (ID: ${item.company.hvac_id})` : "")
          }}</span>
        </template>

        <!-- Brand -->
        <template v-slot:col_brand="{ item }">
          <div v-if="item.enrollableBrands.length > 1" class="element">
            <div class="select-wrapper">
              <select
                class="custom-select"
                v-model="item.selectedBrandId"
                :value="item.defaultBrand.id"
              >
                <option
                  v-for="option in item.enrollableBrands"
                  :key="option.value"
                  :value="option.value"
                >
                  {{ option.label }}
                </option>
              </select>
            </div>
          </div>
          <div v-else>{{ item.defaultBrand.name }}</div>
        </template>

        <!-- "Add to Queue" Button -->
        <template v-slot:list-menu="{ item }">
          <em v-if="!!item.in_queue">Already in Queue</em>
          <em v-else-if="!!item.is_enrolled">Already Enrolled</em>
          <em v-else-if="!item.prerequisites_met">Prerequisites Not Met</em>
          <a
            v-else-if="!item.can_enroll"
            href="#"
            @click.prevent="showError(item.can_enroll_error)"
          >
            <em>Unable to Enroll</em>
          </a>
          <a
            v-else
            href="#"
            @click.prevent="addToQueue(item)"
            class="btn-sm btn-primary font-size-sm d-inline-block btn-add-to-queue"
            >Add to Queue</a
          >
        </template>

        <!-- Card Format (mobile screens) -->
        <template v-slot:list-card="{ item }">
          <div class="card">
            <div class="card-header">
              <div class="row">
                <div class="col-12 col-sm-6 text-center text-sm-left">
                  <h4 class="card-title">{{ item.name }}</h4>
                  <div v-if="!!item.hvac_id" class="card-subtitle">
                    ID: {{ item.hvac_id }}
                  </div>
                </div>
                <div class="d-none d-sm-block col-6 text-right">
                  <em v-if="!!item.in_queue" class="text-muted"
                    >Already in Queue</em
                  >
                  <em v-else-if="!!item.is_enrolled" class="text-muted"
                    >Already Enrolled</em
                  >
                  <em v-else-if="!item.prerequisites_met" class="text-muted"
                    >Prerequisites Not Met</em
                  >
                  <em v-else-if="!item.can_enroll" class="text-muted"
                    >Unable to Enroll</em
                  >
                  <a
                    v-else
                    href="#"
                    @click.prevent="addToQueue(item)"
                    class="btn btn-primary"
                    >Add to Queue</a
                  >
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="card-text mt-0 row">
                <div class="col-12 col-sm-3 font-size-sm">EMAIL:</div>
                <div class="col-12 col-sm-9 font-size-sm mb-3 text-dark">
                  {{ item.email }}
                </div>
                <div class="col-12 col-sm-3 font-size-sm">COMPANY:</div>
                <div class="col-12 col-sm-9 font-size-sm mb-3 text-dark">
                  {{ item.company.name }}
                </div>
                <div class="col-12 col-sm-3 font-size-sm">BRAND:</div>
                <div class="col-12 col-sm-9 font-size-sm">
                  <div v-if="item.enrollableBrands.length > 1" class="element">
                    <div class="select-wrapper">
                      <select
                        class="custom-select"
                        v-model="item.selectedBrandId"
                        :value="(item.selectedBrandId = item.defaultBrand.id)"
                      >
                        <option
                          v-for="option in item.enrollableBrands"
                          :key="option.value"
                          :value="option.value"
                        >
                          {{ option.label }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div v-else class="text-dark">
                    {{ item.defaultBrand.name }}
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer text-center d-sm-none">
              <em v-if="!!item.in_queue" class="text-muted"
                >Already in Queue</em
              >
              <em v-else-if="!!item.is_enrolled" class="text-muted"
                >Already Enrolled</em
              >
              <em v-else-if="!item.prerequisites_met" class="text-muted"
                >Prerequisites Not Met</em
              >
              <em v-else-if="!item.can_enroll" class="text-muted"
                >Unable to Enroll</em
              >
              <a
                v-else
                href="#"
                @click.prevent="addToQueue(item)"
                class="btn btn-primary"
                >Add to Queue</a
              >
            </div>
          </div>
        </template>
      </ListTable>
    </div>

    <div class="col-12 text-center">
      <Pagination
        class="d-inline-block"
        :total="totalPages"
        :value="parseInt(pagination.current)"
        @input="setCurrentPage"
      />
    </div>
  </div>
</template>

<script>
import ListingMixin from "mixins/Listing";
export default {
  mixins: [ListingMixin],

  props: {
    searchParams: { type: Object, default: () => {} },
    coworkers: { type: Array, default: () => [] },
  },

  watch: {
    searchParams: {
      handler: function (val) {
        this.setCurrentPage(1);
        this.refresh();
      },
      deep: true,
    },
  },

  methods: {
    customParams() {
      return this.searchParams;
    },
    addToQueue(user) {
      var selected = user.selectedBrandId || user.defaultBrand.id;
      var brand = user.enrollableBrands.find((b) => b.value == selected);
      user.selectedBrand = { id: brand.value, name: brand.label };
      this.$emit("add-to-queue", user);
    },
    showError(msg) {
      this.$modal("AlertModal", {
        alert: {
          type: "danger",
          message: msg,
        },
      })
        .then(() => {})
        .catch(() => {});
    },
  },

  mounted() {
    if (_.isArray(this.coworkers) && !_.isEmpty(this.coworkers)) {
      this.items = _.cloneDeep(this.coworkers);
    }
  },
};
</script>

<style lang="scss" scoped>
.btn-add-to-queue {
  min-width: 90px;
}
</style>